import React from 'react';
import { type RouteObject } from 'react-router-dom';

import PageLogin from './index';

/**
 * `/login` route for the magic-link sign-in page.
 *
 * Like the configurator wizard, this is a full-bleed experience that owns the
 * whole viewport and brings its own backdrop — so it is mounted as a standalone
 * route (NOT through the account-chrome layouts in `router.tsx`) and is NOT
 * auth-gated: it is the screen an unauthenticated visitor must be able to reach.
 * `src/routes.tsx` prepends it before the config-driven routes so it wins the
 * specificity tie against the remote config's `/login` page.
 */
export const loginRoute: RouteObject = {
  path: '/login',
  element: <PageLogin />,
};

export default loginRoute;
